import type { Preview } from "./types";

/** The bounds core keeps a preview's time within, in minutes. */
export const PREVIEW_TTL_MIN = 5;
export const PREVIEW_TTL_MAX = 1440;

/** An agent's previews still open at `now`, the one closing soonest first. */
export function openPreviewsOf(previews: readonly Preview[], agentId: string, now: number): Preview[] {
  return previews
    .filter((preview) => preview.agentId === agentId && !preview.closedAt && Date.parse(preview.expiresAt) > now)
    .sort((a, b) => Date.parse(a.expiresAt) - Date.parse(b.expiresAt));
}

/** "2h 05m", "12m", "under a minute". */
export function timeLeftLabel(expiresAt: string, now: number): string {
  const minutes = Math.floor((Date.parse(expiresAt) - now) / 60_000);
  if (minutes < 1) return "under a minute";
  if (minutes < 60) return `${minutes}m`;
  return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, "0")}m`;
}

/**
 * The TTL that adds `minutes` to what is left — core sets a new expiry from now —
 * kept within 5 min–24 h, so "+24h" on a preview already near 24 h is simply 24 h.
 */
export function extendedTtl(expiresAt: string, minutes: number, now: number): number {
  const left = Math.max(0, Math.ceil((Date.parse(expiresAt) - now) / 60_000));
  return Math.min(PREVIEW_TTL_MAX, Math.max(PREVIEW_TTL_MIN, left + minutes));
}
